export default __webpack_public_path__ + "static/media/plus-upload-image.0fd5985f.svg";